module.exports = __webpack_public_path__ + "img/new.6af7c3d5.png";